const baseSize = 16;
let timer = null;
let isResizing = false;

// 设置 rem 函数
function setRem() {
  // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / 1920;
  // 设置页面根节点字体大小, 字体大小最小为12
  let minFontSize = 14;
  let fontSize =
    baseSize * Math.min(scale, 2) > minFontSize
      ? baseSize * Math.min(scale, 2)
      : minFontSize;
  document.documentElement.style.fontSize = fontSize + 'px';
  isResizing = false;
}

// 初始化
setRem();

// 改变窗口大小时重新设置 rem，这里加上节流
window.onresize = function () {
  // 如果正在执行 setRem 函数，则不再触发
  if (isResizing) {
    return;
  }
  // 清除之前的定时器
  clearTimeout(timer);
  // 设置一个新的定时器来延迟执行 setRem 函数
  timer = setTimeout(function () {
    isResizing = true;
    setRem();
  }, 200); // 延迟时间可以根据需要调整
};
